import { render, staticRenderFns } from "./Fecalysis.vue?vue&type=template&id=6620f94c&scoped=true&"
import script from "./Fecalysis.vue?vue&type=script&lang=js&"
export * from "./Fecalysis.vue?vue&type=script&lang=js&"
import style0 from "./Fecalysis.vue?vue&type=style&index=0&id=6620f94c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6620f94c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
